var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-master-ui-custom" },
    [
      _c(
        "el-form",
        {
          staticClass: "section",
          staticStyle: { "flex-direction": "row", "line-height": "28px" }
        },
        [
          _c(
            "el-checkbox",
            {
              attrs: { disabled: _vm.viewStatus, no: "isInsure" },
              model: {
                value: _vm.job.insure,
                callback: function($$v) {
                  _vm.$set(_vm.job, "insure", $$v)
                },
                expression: "job.insure"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.InsureInfo")))]
          ),
          _vm.viewSource === "AeBooking"
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["button_insurance_toInsure"],
                      expression: "['button_insurance_toInsure']"
                    }
                  ],
                  staticStyle: { "margin-left": "15px" },
                  attrs: { disabled: !_vm.viewStatus, type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.pm.toInsure()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
              )
            : _vm._e(),
          !!_vm.templateName
            ? _c("div", { staticStyle: { "flex-grow": "1" } }, [
                _c(
                  "span",
                  {
                    staticClass: "blue",
                    staticStyle: {
                      float: "right",
                      "margin-right": "30px",
                      padding: "0 5px",
                      "white-space": "nowrap"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_SopTemplate")) +
                        ": " +
                        _vm._s(_vm.templateName)
                    )
                  ]
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "basicForm",
          staticStyle: { display: "flex" },
          attrs: { "label-position": "right", "label-width": "120px" }
        },
        [
          _c(
            "tab-master-UICustom-layout",
            {
              attrs: {
                "element-blocks": _vm.elementBlocks,
                "element-dict": _vm.elementDict
              }
            },
            [
              _vm.elementDict.jobNo && _vm.elementDict.jobNo.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "jobNo" }, slot: "jobNo" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.jobNo.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.jobNo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { no: "1", disabled: true },
                        model: {
                          value: _vm.job.jobNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "jobNo", $$v)
                          },
                          expression: "job.jobNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isZY
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: { slot: "saleProductCode" },
                        slot: "saleProductCode"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.AllowSaleProduct")))]
                        ),
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type":
                              _vm.selectTypeNames.basic_data_AllowSaleProduct,
                            filterable: "",
                            no: "allowSaleProduct",
                            clearable: "",
                            "data-filter-function": function(p) {
                              if (!p.statusEnabled) {
                                return false
                              }
                              return _vm.isFba ? p.fbaAir : p.airExportEnabled
                            },
                            "default-value": _vm.job.saleProductCode || "",
                            disabled: _vm.viewStatus
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.saleProductCode = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { slot: "fullOrInside" }, slot: "fullOrInside" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.FullOrInside")))]
                        ),
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_FullOrInside$FULL_OR_INSIDE,
                            no: "fullOrInside",
                            clearable: "",
                            "default-value": _vm.job.fullOrInside || "",
                            disabled: _vm.viewStatus
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.fullOrInside = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm.elementDict.mbl && _vm.elementDict.mbl.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "mbl" }, slot: "mbl" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.mbl.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.mbl.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { "margin-right": "2px" },
                          attrs: {
                            disabled:
                              _vm.viewStatus || !_vm.elementDict.mbl.writable,
                            no: "122"
                          },
                          on: { change: _vm.expressChangeHandler },
                          model: {
                            value: _vm.job.express,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "express", $$v)
                            },
                            expression: "job.express"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.ExpressInfo")))]
                      ),
                      !_vm.job.express
                        ? _c("mawb-no-input", {
                            ref: "mawbNoInput",
                            staticStyle: {
                              width: "100%",
                              "margin-bottom": "5px"
                            },
                            attrs: {
                              editable:
                                _vm.viewStatus ||
                                _vm.isEditablemawbNoInput ||
                                !_vm.elementDict.mbl.writable
                            },
                            on: {
                              change: _vm.mblChangeHandler,
                              changeCallback: function($event) {
                                return _vm.mblCheckHandler(true)
                              }
                            },
                            model: {
                              value: _vm.job.mbl,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "mbl", $$v)
                              },
                              expression: "job.mbl"
                            }
                          })
                        : _vm._e(),
                      _vm.job.express
                        ? _c("el-input", {
                            staticStyle: { width: "130px" },
                            attrs: {
                              disabled:
                                _vm.viewStatus || !_vm.elementDict.mbl.writable,
                              no: "21"
                            },
                            on: { change: _vm.mblChange },
                            model: {
                              value: _vm.job.mbl,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "mbl", $$v)
                              },
                              expression: "job.mbl"
                            }
                          })
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                "margin-left": "1px",
                                "padding-left": "10px",
                                "padding-right": "10px"
                              },
                              attrs: {
                                no: "2",
                                type: "primary",
                                disabled: !_vm.selectBtnEnable
                              },
                              on: { click: _vm.selectMBLNoHandler }
                            },
                            [_vm._v(_vm._s(_vm.selectMawbDialog.btnName))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dispatchingPlace &&
              _vm.elementDict.dispatchingPlace.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "dispatchingPlace" },
                      slot: "dispatchingPlace"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dispatchingPlace.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dispatchingPlace.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.dispatchingPlace.writable,
                          no: "77"
                        },
                        model: {
                          value: _vm.job.dispatchingPlace,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "dispatchingPlace", $$v)
                          },
                          expression: "job.dispatchingPlace"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.loadingPortCode &&
              _vm.elementDict.loadingPortCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "loadingPortCode" },
                      slot: "loadingPortCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.loadingPortCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.loadingPortCode.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: {
                              width: "60px",
                              "margin-right": "5px"
                            },
                            attrs: { no: "3", disabled: true },
                            model: {
                              value: _vm.loading3Code,
                              callback: function($$v) {
                                _vm.loading3Code = $$v
                              },
                              expression: "loading3Code"
                            }
                          }),
                          _c("cargo-advance-select", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "4",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Airport,
                              "default-value": _vm.job.loadingPortCode,
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.loadingPortCode.writable,
                              placeholder: " "
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.loadingPortChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.destinationPortCode &&
              _vm.elementDict.destinationPortCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "destinationPortCode" },
                      slot: "destinationPortCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.destinationPortCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.destinationPortCode.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: {
                              width: "60px",
                              "margin-right": "5px"
                            },
                            attrs: { no: "5", disabled: true },
                            model: {
                              value: _vm.destination3Code,
                              callback: function($$v) {
                                _vm.destination3Code = $$v
                              },
                              expression: "destination3Code"
                            }
                          }),
                          _c("cargo-advance-select", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "6",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Airport,
                              "default-value": _vm.job.destinationPortCode,
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.destinationPortCode.writable,
                              placeholder: " "
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.destinationPortCodeChange(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.destinationPlace &&
              _vm.elementDict.destinationPlace.viewable
                ? _c(
                    "template",
                    { slot: "destinationPlace" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("line-label", {
                            class: _vm.elementDict.destinationPlace.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.destinationPlace.label
                            },
                            slot: "label"
                          }),
                          _c("el-input", {
                            attrs: {
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.destinationPlace.writable,
                              no: "7"
                            },
                            on: {
                              input: function(val) {
                                _vm.job.destinationPlace = val
                                  ? val.toUpperCase()
                                  : ""
                              }
                            },
                            model: {
                              value: _vm.job.destinationPlace,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "destinationPlace", $$v)
                              },
                              expression: "job.destinationPlace"
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-form-item", { attrs: { label: "" } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c(
                              "el-checkbox",
                              {
                                attrs: { no: "8" },
                                model: {
                                  value: _vm.job.transfering,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "transfering", $$v)
                                  },
                                  expression: "job.transfering"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Transit2")))]
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  width: "100%",
                                  overflow: "hidden",
                                  "text-overflow": "ellipsis",
                                  "margin-left": "2px"
                                },
                                attrs: {
                                  no: "9",
                                  title: _vm.$t("SeaExport.EnterTransitInfo"),
                                  type: "primary",
                                  disabled:
                                    _vm.viewStatus ||
                                    (!_vm.viewStatus && !_vm.job.transfering) ||
                                    !_vm.elementDict.destinationPlace.writable
                                },
                                on: { click: _vm.setTransferingHandler }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.EnterTransitInfo"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoSource &&
              _vm.elementDict.cargoSource.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "cargoSource" }, slot: "cargoSource" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoSource.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoSource.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "10",
                              clearable: false,
                              filterable: "",
                              fields: ["chineseName"],
                              "select-type":
                                _vm.selectTypeNames.local_cache_CargoSource,
                              "callback-method-type": "value",
                              "default-value": _vm.job.cargoSource,
                              "callback-params": { key: "cargoSource" },
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.cargoSource.writable
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.serviceProduct &&
              _vm.elementDict.serviceProduct.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "serviceProduct" },
                      slot: "serviceProduct"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.serviceProduct.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.serviceProduct.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "145",
                              clearable: false,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames
                                  .basic_data_AirServiceProduct,
                              "callback-method-type": "value",
                              "default-value": _vm.job.serviceProduct,
                              "callback-params": { key: "serviceProduct" },
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.serviceProduct.writable
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.airlineProductUuid &&
              _vm.elementDict.airlineProductUuid.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "airlineProductUuid" },
                      slot: "airlineProductUuid"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.airlineProductUuid.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.airlineProductUuid.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "airlineProductUuid",
                              filterable: "",
                              "static-options": _vm.airlineProductDownList,
                              "method-params": { active: true },
                              "tag-value": "uuid",
                              "tag-name": "name",
                              "filter-tag-names": ["name"],
                              "static-component": new _vm.AutoComplete(),
                              "callback-method-type": "value",
                              "default-value": _vm.job.airlineProductUuid,
                              "callback-params": { key: "airlineProductUuid" },
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.airlineProductUuid.writable
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customJobType &&
              _vm.elementDict.customJobType.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "customJobType" }, slot: "customJobType" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customJobType.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customJobType.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "11",
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CutomJobType,
                          "default-value": _vm.job.customJobType,
                          "method-params": { type: _vm.job.lob },
                          "static-options": _vm.customJobTypeList,
                          placeholder: " ",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.customJobType.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.customJobType = p.value
                            _vm.oncustomJobTypeChange(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.secondaryCustomJobType &&
                        _vm.elementDict.secondaryCustomJobType.viewable &&
                        _vm.job.customJobType &&
                        _vm.secondaryCustomJobTypeList.length > 0,
                      expression:
                        "elementDict.secondaryCustomJobType && elementDict.secondaryCustomJobType.viewable && job.customJobType && secondaryCustomJobTypeList.length > 0"
                    }
                  ],
                  attrs: { slot: "secondaryCustomJobType" },
                  slot: "secondaryCustomJobType"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.secondaryCustomJobType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.secondaryCustomJobType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    ref: "secondaryCustomJobType",
                    attrs: {
                      no: "secondaryCustomJobType",
                      "select-type":
                        _vm.selectTypeNames.basic_data_CutomJobType,
                      filterable: "",
                      cache: false,
                      "default-value": _vm.job.secondaryCustomJobType,
                      "tag-name": _vm.isZh ? "name" : "englishName",
                      "static-options": _vm.secondaryCustomJobTypeList,
                      disabled:
                        _vm.viewStatus ||
                        !_vm.elementDict.secondaryCustomJobType.writable
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.secondaryCustomJobType = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.destinationAgent &&
              _vm.elementDict.destinationAgent.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "destinationAgent" },
                      slot: "destinationAgent"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.destinationAgent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.destinationAgent.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "12",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { overseaAgent: true, active: true },
                          "default-value": _vm.job.destinationAgent || "",
                          "tag-name": "englishName",
                          placeholder: " ",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.destinationAgent.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.destinationAgentChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.designationAgent &&
              _vm.elementDict.designationAgent.viewable &&
              _vm.job.cargoSource === "NC"
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "designationAgent" },
                      slot: "designationAgent"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.designationAgent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.designationAgent.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "13",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            designationAgent: true,
                            active: true
                          },
                          "callback-method-type": "value",
                          "default-value": _vm.job.designationAgent || "",
                          "tag-name": "englishName",
                          "callback-params": { key: "designationAgent" },
                          disabled:
                            _vm.viewStatus ||
                            !_vm.designationAgentEnabled ||
                            !_vm.elementDict.designationAgent.writable,
                          placeholder: " "
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.exChangeAgent &&
              _vm.elementDict.exChangeAgent.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "exChangeAgent" }, slot: "exChangeAgent" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.exChangeAgent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.exChangeAgent.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-company-select", {
                        attrs: {
                          no: "exChangeAgent",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.job.dischargingPortDoor ||
                            !_vm.elementDict.exChangeAgent.writable,
                          "method-params": { bookingAgent: true, active: true },
                          "default-value": _vm.job.exChangeAgent || ""
                        },
                        on: { change: _vm.onExChangeAgentChange }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bookingAgent &&
              _vm.elementDict.bookingAgent.viewable &&
              _vm.bookingAgentVisible
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "bookingAgent" }, slot: "bookingAgent" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bookingAgent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bookingAgent.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "14",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { bookingAgent: true, active: true },
                          "callback-method-type": "value",
                          "default-value": _vm.job.bookingAgent || "",
                          "callback-params": { key: "bookingAgent" },
                          disabled:
                            _vm.viewStatus ||
                            !_vm.bookingAgentEnabled ||
                            !_vm.elementDict.bookingAgent.writable,
                          placeholder: " "
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.fileCutoff && _vm.elementDict.fileCutoff.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "fileCutoff" }, slot: "fileCutoff" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.fileCutoff.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.fileCutoff.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        ref: "fileCutoff",
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "15",
                          type: "datetime",
                          clearable: "",
                          format: "yyyy-MM-dd HH:mm",
                          "value-format": "yyyy-MM-dd HH:mm",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.fileCutoff.writable
                        },
                        on: {
                          blur: function() {
                            _vm.handleBlur(
                              "fileCutoff",
                              null,
                              true,
                              false,
                              _vm.job
                            )
                          }
                        },
                        model: {
                          value: _vm.job.fileCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "fileCutoff", $$v)
                          },
                          expression: "job.fileCutoff"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.airUlds && _vm.elementDict.airUlds.viewable
                ? _c("booking-air-uld-data-grid", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      slot: "airUlds",
                      value: _vm.airUlds,
                      "is-edit":
                        !_vm.viewStatus && _vm.elementDict.airUlds.writable,
                      job: _vm.job
                    },
                    slot: "airUlds"
                  })
                : _vm._e(),
              _vm.elementDict.carrierId && _vm.elementDict.carrierId.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "carrierId", "label-width": "120px" },
                      slot: "carrierId"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.carrierId.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.carrierId.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "34",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { airCmp: true, active: true },
                          "default-value": _vm.job.carrierId || "",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.carrierIdEnabled ||
                            !_vm.elementDict.carrierId.writable,
                          headers: [
                            _vm.$t("Tool.ShortName"),
                            _vm.$t("Partners.chineseName")
                          ],
                          fields: ["shortName", "chineseName"],
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.carrierChangeHandler(p.value || 0)
                            _vm.pm.airlineCompanyChange(p.value || 0)
                            _vm.airlineCompanyCheckHandler(p.value || 0)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.carrierWebsite &&
              _vm.elementDict.carrierWebsite.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "carrierWebsite" },
                      slot: "carrierWebsite"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.carrierWebsite.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.carrierWebsite.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-textarea", {
                        attrs: {
                          no: "carrierWebsite",
                          type: "textarea",
                          row: 3,
                          disabled: !_vm.elementDict.carrierWebsite.writable
                        },
                        model: {
                          value: _vm.job.carrierWebsite,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "carrierWebsite", $$v)
                          },
                          expression: "job.carrierWebsite"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.voyageFlight &&
              _vm.elementDict.voyageFlight.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "voyageFlight", "label-width": "120px" },
                      slot: "voyageFlight"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.voyageFlight.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.voyageFlight.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.voyageFlight.writable,
                          no: "35"
                        },
                        on: { change: _vm.voyageFlightCheckHandler },
                        model: {
                          value: _vm.job.voyageFlight,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "voyageFlight", $$v)
                          },
                          expression: "job.voyageFlight"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customsDate &&
              _vm.elementDict.customsDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customsDate", "label-width": "120px" },
                      slot: "customsDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customsDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customsDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.customsDate.writable,
                          no: "36",
                          "value-format": "yyyy-MM-dd",
                          type: "date",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.customsDate,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "customsDate", $$v)
                          },
                          expression: "job.customsDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.etd && _vm.elementDict.etd.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "etd", "label-width": "120px" },
                      slot: "etd"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.etd.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.etd.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            ref: "etd",
                            staticStyle: {
                              flex: "1",
                              width: "140px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              value: _vm.job.etd,
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.etd.writable ||
                                _vm.provisionEtdLocked,
                              no: "37",
                              clearable: "",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            on: {
                              input: _vm.etdChange,
                              blur: function() {
                                _vm.handleBlur(
                                  "etd",
                                  _vm.etdChange,
                                  false,
                                  false,
                                  _vm.job
                                )
                              }
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm._f("filterWeek")(_vm.job.sailingDay))
                            )
                          ])
                        ],
                        1
                      ),
                      _vm.provisionEtdLocked
                        ? _c(
                            "span",
                            {
                              staticStyle: { color: "red", "font-size": "12px" }
                            },
                            [_vm._v("(已计提校准不可修改)")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.eta && _vm.elementDict.eta.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "eta", "label-width": "120px" },
                      slot: "eta"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.eta.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.eta.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            ref: "eta",
                            staticStyle: {
                              flex: "1",
                              width: "140px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              disabled:
                                _vm.viewStatus || !_vm.elementDict.eta.writable,
                              no: "38",
                              type: "datetime",
                              clearable: "",
                              "value-format": "yyyy-MM-dd HH:mm",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            on: {
                              input: _vm.etaChange,
                              blur: function() {
                                _vm.handleBlur(
                                  "eta",
                                  _vm.etaChange,
                                  false,
                                  false,
                                  _vm.job
                                )
                              }
                            },
                            model: {
                              value: _vm.job.eta,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "eta", $$v)
                              },
                              expression: "job.eta"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.job.etaSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.atd && _vm.elementDict.atd.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "atd", "label-width": "120px" },
                      slot: "atd"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.atd.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.atd.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            ref: "atd",
                            staticStyle: {
                              flex: "1",
                              width: "140px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              value: _vm.job.atd,
                              no: "39",
                              disabled:
                                _vm.viewStatus || !_vm.elementDict.atd.writable,
                              type: "datetime",
                              clearable: "",
                              "value-format": "yyyy-MM-dd HH:mm",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            on: {
                              input: _vm.atdChange,
                              blur: function() {
                                _vm.handleBlur(
                                  "atd",
                                  _vm.atdChange,
                                  false,
                                  false,
                                  _vm.job
                                )
                              }
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.job.atdSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.ata && _vm.elementDict.ata.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "ata", "label-width": "120px" },
                      slot: "ata"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.ata.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.ata.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            ref: "ata",
                            staticStyle: {
                              flex: "1",
                              width: "140px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              no: "40",
                              disabled:
                                _vm.viewStatus || !_vm.elementDict.ata.writable,
                              type: "datetime",
                              clearable: "",
                              "value-format": "yyyy-MM-dd HH:mm",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            on: {
                              input: _vm.ataChange,
                              blur: function() {
                                _vm.handleBlur(
                                  "ata",
                                  _vm.ataChange,
                                  false,
                                  false,
                                  _vm.job
                                )
                              }
                            },
                            model: {
                              value: _vm.job.ata,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "ata", $$v)
                              },
                              expression: "job.ata"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.job.ataSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoCode && _vm.elementDict.cargoCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "cargoCode", "label-width": "120px" },
                      slot: "cargoCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "42",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CargoInformation,
                          filterable: "",
                          "callback-params": { key: "cargoCode" },
                          "default-value": _vm.job.cargoCode,
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.cargoCode.writable,
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: _vm.txtCargoInformationChangeHandler
                        }
                      }),
                      _c("el-input", {
                        attrs: { disabled: !_vm.job.cargoCode },
                        model: {
                          value: _vm.job.cargoName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoName", $$v)
                          },
                          expression: "job.cargoName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.transportSource &&
              _vm.elementDict.transportSource.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "transportSource",
                        "label-width": "120px"
                      },
                      slot: "transportSource"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.transportSource.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.transportSource.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TransportSource,
                          no: "transportSource",
                          "default-value": _vm.job.transportSource,
                          cache: false,
                          "tag-value": "code",
                          placeholder: " ",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.transportSource.writable
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.job.transportSource = item.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.statisticArea &&
              _vm.elementDict.statisticArea.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "statisticArea", "label-width": "120px" },
                      slot: "statisticArea"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.statisticArea.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.statisticArea.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_StatisticArea,
                          no: "statisticArea",
                          "default-value": _vm.job.statisticArea,
                          cache: false,
                          "tag-value": "code",
                          placeholder: " ",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.statisticArea.writable
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.job.statisticArea = item.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.paymentTermMBL &&
              _vm.elementDict.paymentTermMBL.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "paymentTermMBL" },
                      slot: "paymentTermMBL"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.paymentTermMBL.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.paymentTermMBL.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "43",
                          filterable: "",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentTerm,
                          "default-value": _vm.job.paymentTermMBL || "",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.paymentTermMBL.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            return _vm.pm.paymentTermMBLChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bookingTerm &&
              _vm.elementDict.bookingTerm.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "bookingTerm" }, slot: "bookingTerm" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bookingTerm.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bookingTerm.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "44",
                          filterable: "",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames.local_cache_BookingTerm,
                          "default-value": _vm.job.bookingTerm,
                          fields: ["chineseName"],
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.bookingTerm.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.bookingTermChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.portOfDestinationServices &&
              _vm.elementDict.portOfDestinationServices.viewable &&
              _vm.isAeBooking
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "portOfDestinationServices" },
                      slot: "portOfDestinationServices"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.portOfDestinationServices
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.portOfDestinationServices.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-checkbox",
                        {
                          staticClass: "checkbox-content",
                          attrs: {
                            disabled:
                              _vm.viewStatus ||
                              !_vm.elementDict.portOfDestinationServices
                                .writable,
                            no: "dischargingPortDoor",
                            title: _vm.$t(
                              "SeaExport.DispatchVehiclesAtDestination"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.syncSlaves("dischargingPortDoor")
                            }
                          },
                          model: {
                            value: _vm.job.dischargingPortDoor,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "dischargingPortDoor", $$v)
                            },
                            expression: "job.dischargingPortDoor"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SeaExport.DispatchVehiclesAtDestination")
                            ) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticClass: "checkbox-content",
                          attrs: {
                            disabled:
                              _vm.viewStatus ||
                              !_vm.elementDict.portOfDestinationServices
                                .writable,
                            no: "usCustomsClearance",
                            title: _vm.$t("queryJob.UsCustomsClearance")
                          },
                          on: {
                            change: function($event) {
                              return _vm.syncSlaves("usCustomsClearance")
                            }
                          },
                          model: {
                            value: _vm.job.usCustomsClearance,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "usCustomsClearance", $$v)
                            },
                            expression: "job.usCustomsClearance"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("queryJob.UsCustomsClearance")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          staticClass: "checkbox-content",
                          attrs: {
                            disabled:
                              _vm.viewStatus ||
                              !_vm.elementDict.portOfDestinationServices
                                .writable,
                            no: "destPortCustomsClearance",
                            title: _vm.$t(
                              "SeaExport.PortOfDestinationCustomsClearance"
                            )
                          },
                          model: {
                            value: _vm.job.destPortCustomsClearance,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "destPortCustomsClearance", $$v)
                            },
                            expression: "job.destPortCustomsClearance"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SeaExport.PortOfDestinationCustomsClearance"
                              )
                            ) + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoType && _vm.elementDict.cargoType.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "cargoType" }, slot: "cargoType" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoType.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoType.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "45",
                          filterable: "",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames.basic_data_CargoType,
                          "callback-method-type": "value",
                          "default-value": _vm.job.cargoType,
                          "callback-params": { key: "cargoType" },
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.cargoType.writable
                        },
                        on: { parentCallBack: _vm.onCargoTypeChagne }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.salesChannel &&
              _vm.elementDict.salesChannel.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "salesChannel" }, slot: "salesChannel" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.salesChannel.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.salesChannel.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, no: "82" },
                        model: {
                          value: _vm.job.salesChannel,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "salesChannel", $$v)
                          },
                          expression: "job.salesChannel"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.trustFromJob &&
              _vm.elementDict.trustFromJob.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "trustFromJob" }, slot: "trustFromJob" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.trustFromJob.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.trustFromJob.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, no: "trustFromJob" },
                        model: {
                          value: _vm.job.trustFromJob,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "trustFromJob", $$v)
                          },
                          expression: "job.trustFromJob"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.relatedJob && _vm.elementDict.relatedJob.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "relatedJob" }, slot: "relatedJob" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.relatedJob.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.relatedJob.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, no: "relatedJob" },
                        model: {
                          value: _vm.job.relatedJob,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "relatedJob", $$v)
                          },
                          expression: "job.relatedJob"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.channelNo &&
              _vm.elementDict.channelNo.viewable &&
              _vm.showChannelNo
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "channelNo" }, slot: "channelNo" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.channelNo.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.channelNo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, no: "83" },
                        model: {
                          value: _vm.job.channelNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "channelNo", $$v)
                          },
                          expression: "job.channelNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.measurements &&
              _vm.elementDict.measurements.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "measurements" }, slot: "measurements" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.measurements.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.measurements.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          no: "47",
                          type: "textarea",
                          rows: 5,
                          disabled: true
                        },
                        model: {
                          value: _vm.measurements,
                          callback: function($$v) {
                            _vm.measurements = $$v
                          },
                          expression: "measurements"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.remarks && _vm.elementDict.remarks.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "remarks" }, slot: "remarks" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.remarks.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.remarks.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.viewStatus || !_vm.elementDict.remarks.writable,
                          no: "48",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.remarks.label,
                              _vm.job.remarks,
                              function(val) {
                                _vm.job.remarks = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "remarks", $$v)
                          },
                          expression: "job.remarks"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.frontEndWarehouseOperation &&
              _vm.elementDict.frontEndWarehouseOperation.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "frontEndWarehouseOperation" },
                      slot: "frontEndWarehouseOperation"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.frontEndWarehouseOperation
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.frontEndWarehouseOperation &&
                            _vm.elementDict.frontEndWarehouseOperation.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "frontEndWarehouseOperation",
                          "select-type":
                            _vm.selectTypeNames.basic_data_AirportCargoTerminal,
                          "method-params": { dataType: 1, deletionFlag: false },
                          filterable: "",
                          clearable: true,
                          "default-value": _vm.job.frontEndWarehouseOperation,
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.frontEndWarehouseOperation.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.frontEndWarehouseOperation = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.agentInformation &&
              _vm.elementDict.agentInformation.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "agentInformation" },
                      slot: "agentInformation"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.agentInformation.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.agentInformation.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-textarea", {
                        attrs: {
                          no: "agentInformation",
                          type: "textarea",
                          row: 3,
                          disabled: !_vm.elementDict.agentInformation.writable
                        },
                        model: {
                          value: _vm.job.agentInformation,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "agentInformation", $$v)
                          },
                          expression: "job.agentInformation"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoTerminalOperation &&
              _vm.elementDict.cargoTerminalOperation.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "cargoTerminalOperation" },
                      slot: "cargoTerminalOperation"
                    },
                    [
                      _c("line-label", {
                        class:
                          _vm.elementDict.cargoTerminalOperation &&
                          _vm.elementDict.cargoTerminalOperation.isRequire
                            ? "blue"
                            : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.cargoTerminalOperation &&
                            _vm.elementDict.cargoTerminalOperation.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "cargoTerminalOperation",
                          "select-type":
                            _vm.selectTypeNames.basic_data_AirportCargoTerminal,
                          "method-params": { dataType: 0, deletionFlag: false },
                          filterable: "",
                          clearable: true,
                          "default-value": _vm.job.cargoTerminalOperation,
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.cargoTerminalOperation.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.cargoTerminalOperation = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.estimatedDeliveryDate &&
              _vm.elementDict.estimatedDeliveryDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "estimatedDeliveryDate" },
                      slot: "estimatedDeliveryDate"
                    },
                    [
                      _c("line-label", {
                        class:
                          _vm.elementDict.estimatedDeliveryDate &&
                          _vm.elementDict.estimatedDeliveryDate.isRequire
                            ? "blue"
                            : "",
                        attrs: {
                          slot: "label",
                          label:
                            _vm.elementDict.estimatedDeliveryDate &&
                            _vm.elementDict.estimatedDeliveryDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: {
                          flex: "1",
                          width: "200px",
                          "margin-right": "5px"
                        },
                        attrs: {
                          disabled:
                            !_vm.isEdit ||
                            !_vm.job.cargoTerminalOperation ||
                            !_vm.elementDict.estimatedDeliveryDate.writable,
                          no: "estimatedDeliveryDate",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.estimatedDeliveryDate,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "estimatedDeliveryDate", $$v)
                          },
                          expression: "job.estimatedDeliveryDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customerRefNo &&
              _vm.elementDict.customerRefNo.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "customerRefNo" }, slot: "customerRefNo" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customerRefNo.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customerRefNo.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-input", {
                        attrs: {
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.customerRefNo.writable,
                          no: "76",
                          trim: true
                        },
                        model: {
                          value: _vm.job.customerRefNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "customerRefNo", $$v)
                          },
                          expression: "job.customerRefNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.tradeTerm && _vm.elementDict.tradeTerm.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "tradeTerm" }, slot: "tradeTerm" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.tradeTerm.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.tradeTerm.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "50",
                          filterable: "",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames.basic_data_TradeTerm,
                          "callback-method-type": "value",
                          "default-value": _vm.job.tradeTerm,
                          "callback-params": { key: "tradeTerm" },
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.tradeTerm.writable
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dcOffice && _vm.elementDict.dcOffice.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "dcOffice" }, slot: "dcOffice" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dcOffice.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dcOffice.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-office-select", {
                        attrs: {
                          no: "dcOffice",
                          disabled: true,
                          "office-id": Number(_vm.job.dcOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.dcOffice = p.value
                            _vm.job.dcDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dcDepartment &&
              _vm.elementDict.dcDepartment.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "dcDepartment" }, slot: "dcDepartment" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dcDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dcDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "dcDepartment",
                          "office-id": Number(_vm.job.dcOffice),
                          enables: true,
                          "department-id": Number(_vm.job.dcDepartment),
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.dcDepartment.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.job.dcDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.elementDict.dc && _vm.elementDict.dc.viewable,
                      expression: "elementDict.dc && elementDict.dc.viewable"
                    }
                  ],
                  attrs: { slot: "dc" },
                  slot: "dc"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dc.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.dc.label },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "dc",
                    attrs: {
                      no: "51",
                      "method-params": { category: "role", shape: "doc" },
                      "default-value": _vm.job.dc || "",
                      placeholder: " ",
                      "static-options": _vm.userPortRoleData.doc,
                      disabled: _vm.viewStatus || !_vm.elementDict.dc.writable
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.dcChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.plannerOffice &&
              _vm.elementDict.plannerOffice.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "plannerOffice" }, slot: "plannerOffice" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.plannerOffice.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.plannerOffice.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-office-select", {
                        attrs: {
                          no: "plannerOffice",
                          disabled: true,
                          "office-id": Number(_vm.job.plannerOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.plannerOffice = p.value
                            _vm.job.plannerDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.plannerDepartment &&
              _vm.elementDict.plannerDepartment.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "plannerDepartment" },
                      slot: "plannerDepartment"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.plannerDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.plannerDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "plannerDepartment",
                          "office-id": Number(_vm.job.plannerOffice),
                          enables: true,
                          "department-id": Number(_vm.job.plannerDepartment),
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.plannerDepartment.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.job.plannerDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.planner && _vm.elementDict.planner.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "planner" }, slot: "planner" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.planner.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.planner.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        attrs: {
                          no: "52",
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "airline"
                          },
                          "default-value": _vm.job.planner || "",
                          placeholder: " ",
                          "static-options": _vm.userPortRoleData.airline,
                          disabled:
                            _vm.viewStatus || !_vm.elementDict.planner.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.plannerChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.siteOP && _vm.elementDict.siteOP.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "siteOP" }, slot: "siteOP" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.siteOP.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.siteOP.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        attrs: {
                          no: "53",
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "siteOp"
                          },
                          "default-value": _vm.job.siteOP || "",
                          placeholder: " ",
                          "static-options": _vm.userPortRoleData.siteOp,
                          disabled:
                            _vm.viewStatus || !_vm.elementDict.siteOP.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.JobUtils.siteOpChangeHandler(_vm.job, p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoSalesId &&
              _vm.elementDict.cargoSalesId.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "cargoSalesId" }, slot: "cargoSalesId" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoSalesId.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoSalesId.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        attrs: {
                          no: "54",
                          "method-params": {
                            category: "role",
                            shape: "salesOfGoods"
                          },
                          "default-value": _vm.job.cargoSalesId || "",
                          placeholder: " ",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.cargoSalesId.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.job.cargoSalesId = p.value
                            _vm.pm.cargoSalesChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.txtSalesOffice &&
              _vm.elementDict.txtSalesOffice.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "txtSalesOffice" },
                      slot: "txtSalesOffice"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.txtSalesOffice.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.txtSalesOffice.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { no: "55", disabled: true },
                        model: {
                          value: _vm.txtSalesOffice,
                          callback: function($$v) {
                            _vm.txtSalesOffice = $$v
                          },
                          expression: "txtSalesOffice"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.salesDepartment &&
              _vm.elementDict.salesDepartment.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "salesDepartment" },
                      slot: "salesDepartment"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.salesDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.salesDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-new-select", {
                        attrs: {
                          no: "56",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.job.sales ||
                            !_vm.elementDict.salesDepartment.writable,
                          enables: true,
                          "sales-id": Number(_vm.job.sales),
                          "office-id": _vm.job.salesOffice,
                          "department-id": Number(_vm.job.salesDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.salesDepartmentChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.sales && _vm.elementDict.sales.viewable,
                      expression:
                        "elementDict.sales && elementDict.sales.viewable"
                    }
                  ],
                  attrs: { slot: "sales" },
                  slot: "sales"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.sales.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.sales.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "sales",
                        staticStyle: { width: "130px", flex: "1" },
                        attrs: {
                          no: "57",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.saleEnabled ||
                            !_vm.elementDict.sales.writable,
                          "method-params": {
                            officeId: _vm.pm.salesOfficeCheck
                              ? _vm.$store.getters.currentOfficeId
                              : "",
                            category: "role",
                            shape: "sales",
                            active: true
                          },
                          "default-value": _vm.job.sales || "",
                          "static-options": _vm.salesList,
                          placeholder: _vm.salesPrompt || " "
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.salesChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.elementDict.opOffice && _vm.elementDict.opOffice.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "opOffice" }, slot: "opOffice" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.opOffice.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.opOffice.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-office-select", {
                        attrs: {
                          no: "58",
                          disabled:
                            _vm.viewStatus ||
                            _vm.opOfficeDisabled ||
                            !_vm.elementDict.opOffice.writable,
                          "office-id": Number(_vm.job.opOffice),
                          placeholder: " ",
                          "is-regional-commission": _vm.isRegionalCommission
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.opOfficeChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.opDepartment &&
              _vm.elementDict.opDepartment.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "opDepartment" }, slot: "opDepartment" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.opDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.opDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "59",
                          "office-id": Number(_vm.job.opOffice),
                          enables: true,
                          "department-id": Number(_vm.job.opDepartment),
                          placeholder: " ",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.opDepartment.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.job.opDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.op && _vm.elementDict.op.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "op" }, slot: "op" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.op.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.op.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        attrs: {
                          no: "60",
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "op"
                          },
                          "default-value": _vm.job.op || "",
                          placeholder: " ",
                          "static-options": _vm.userPortRoleData.op,
                          disabled:
                            _vm.viewStatus || !_vm.elementDict.op.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.opChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.csrOffice && _vm.elementDict.csrOffice.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "csrOffice" }, slot: "csrOffice" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.csrOffice.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.csrOffice.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-office-select", {
                        attrs: {
                          no: "csrOffice",
                          disabled: true,
                          "office-id": Number(_vm.job.csrOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.csrOffice = p.value
                            _vm.job.csrDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.csrDepartment &&
              _vm.elementDict.csrDepartment.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "csrDepartment" }, slot: "csrDepartment" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.csrDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.csrDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "csrDepartment",
                          "office-id": Number(_vm.job.csrOffice),
                          enables: true,
                          "department-id": Number(_vm.job.csrDepartment),
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.csrDepartment.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.job.csrDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.csr && _vm.elementDict.csr.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "csr" }, slot: "csr" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.csr.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.csr.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        attrs: {
                          no: "61",
                          "method-params": { category: "role", shape: "csr" },
                          "default-value": _vm.job.csr || "",
                          placeholder: " ",
                          "static-options": _vm.userPortRoleData.csr,
                          disabled:
                            _vm.viewStatus || !_vm.elementDict.csr.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.csrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.userDefinedRoleId1 &&
                        _vm.elementDict.userDefinedRoleId1.viewable &&
                        _vm.isAddUserDefinedRoles,
                      expression:
                        "elementDict.userDefinedRoleId1 && elementDict.userDefinedRoleId1.viewable && isAddUserDefinedRoles"
                    }
                  ],
                  attrs: { slot: "userDefinedRoleId1" },
                  slot: "userDefinedRoleId1"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId1.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId1.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId1",
                    attrs: {
                      no: "userDefinedRoleId1",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole1"
                      },
                      "default-value": _vm.job.userDefinedRoleId1 || "",
                      "merge-load": true,
                      placeholder: " ",
                      "static-options": _vm.userPortRoleData.userDefinedRole1,
                      disabled:
                        _vm.viewStatus ||
                        !_vm.elementDict.userDefinedRoleId1.writable
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId1Handler(p)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.userDefinedRoleId2 &&
                        _vm.elementDict.userDefinedRoleId2.viewable &&
                        _vm.isAddUserDefinedRoles,
                      expression:
                        "elementDict.userDefinedRoleId2 && elementDict.userDefinedRoleId2.viewable && isAddUserDefinedRoles"
                    }
                  ],
                  attrs: { slot: "userDefinedRoleId2" },
                  slot: "userDefinedRoleId2"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId2.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId2.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId2",
                    attrs: {
                      no: "userDefinedRoleId2",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole2"
                      },
                      "default-value": _vm.job.userDefinedRoleId2 || "",
                      "merge-load": true,
                      placeholder: " ",
                      "static-options": _vm.userPortRoleData.userDefinedRole2,
                      disabled:
                        _vm.viewStatus ||
                        !_vm.elementDict.userDefinedRoleId2.writable
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId2Handler(p)
                      }
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.userDefinedRoleId3 &&
              _vm.elementDict.userDefinedRoleId3.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId3" },
                      slot: "userDefinedRoleId3"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId3.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId3.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId3",
                        attrs: {
                          no: "userDefinedRoleId3",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.userDefinedRoleId3.writable,
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole3"
                          },
                          "default-value": _vm.job.userDefinedRoleId3 || "",
                          "merge-load": true,
                          "static-options":
                            _vm.userPortRoleData.userDefinedRole3
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId3Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId4 &&
              _vm.elementDict.userDefinedRoleId4.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId4" },
                      slot: "userDefinedRoleId4"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId4.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId4.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId4",
                        attrs: {
                          no: "userDefinedRoleId4",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.userDefinedRoleId4.writable,
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole4"
                          },
                          "default-value": _vm.job.userDefinedRoleId4 || "",
                          "merge-load": true,
                          "static-options":
                            _vm.userPortRoleData.userDefinedRole4
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId4Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId5 &&
              _vm.elementDict.userDefinedRoleId5.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId5" },
                      slot: "userDefinedRoleId5"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId5.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId5.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId5",
                        attrs: {
                          no: "userDefinedRoleId5",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole5"
                          },
                          "default-value": _vm.job.userDefinedRoleId5 || "",
                          "merge-load": true,
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.userDefinedRoleId5.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId5Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId6 &&
              _vm.elementDict.userDefinedRoleId6.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId6" },
                      slot: "userDefinedRoleId6"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId6.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId6.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId6",
                        attrs: {
                          no: "userDefinedRoleId6",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole6"
                          },
                          "default-value": _vm.job.userDefinedRoleId6 || "",
                          "merge-load": true,
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.userDefinedRoleId6.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId6Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId7 &&
              _vm.elementDict.userDefinedRoleId7.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId7" },
                      slot: "userDefinedRoleId7"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId7.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId7.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId7",
                        attrs: {
                          no: "userDefinedRoleId7",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole7"
                          },
                          "default-value": _vm.job.userDefinedRoleId7 || "",
                          "merge-load": true,
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.userDefinedRoleId7.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId7Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId8 &&
              _vm.elementDict.userDefinedRoleId8.viewable &&
              _vm.isAddUserDefinedRoles
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId8" },
                      slot: "userDefinedRoleId8"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId8.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId8.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId8",
                        attrs: {
                          no: "userDefinedRoleId8",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole8"
                          },
                          "default-multiple-value": _vm.toNumArray(
                            _vm.job.userDefinedRoleId8
                          ),
                          multiple: true,
                          "merge-load": true,
                          placeholder: _vm.viewStatus ? " " : "",
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.userDefinedRoleId8.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.job.userDefinedRoleId8 = _vm.toTxt(p.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isFba
                ? _c(
                    "div",
                    { staticClass: "section form-column" },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            disabled: _vm.viewStatus,
                            "label-width": "120px",
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("AirExport.ServiceChannel")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "serviceChannel" },
                                model: {
                                  value: _vm.fbaJob.serviceChannel,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "serviceChannel", $$v)
                                  },
                                  expression: "fbaJob.serviceChannel"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "AirExport.EstimatedStorageGoodArrivalTime"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "preWarehousingTime",
                                  type: "datetime",
                                  clearable: "",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.fbaJob.preWarehousingTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.fbaJob,
                                      "preWarehousingTime",
                                      $$v
                                    )
                                  },
                                  expression: "fbaJob.preWarehousingTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-form-item", [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_Destination"))
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { staticStyle: { display: "flex", flex: "1" } },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.fbaJob.warehouseCode,
                                      placement: "bottom-end"
                                    }
                                  },
                                  [
                                    _c("el-cascader", {
                                      staticStyle: { "padding-right": "2px" },
                                      attrs: {
                                        options: _vm.destinations,
                                        filterable: "",
                                        clearable: true,
                                        no: "84"
                                      },
                                      on: {
                                        focus: function($event) {
                                          return _vm.JobUtils.focusWarehouseCode(
                                            _vm.fbaJob
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.JobUtils.blurWarehouseCode(
                                            _vm.fbaJob
                                          )
                                        },
                                        change: function(p) {
                                          _vm.JobUtils.warehouseCodeHandler(
                                            _vm.fbaJob,
                                            p
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.fbaJob.warehouseCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.fbaJob,
                                            "warehouseCode",
                                            $$v
                                          )
                                        },
                                        expression: "fbaJob.warehouseCode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: { no: "remoteWarehouse" },
                                    model: {
                                      value: _vm.fbaJob.remoteWarehouse,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.fbaJob,
                                          "remoteWarehouse",
                                          $$v
                                        )
                                      },
                                      expression: "fbaJob.remoteWarehouse"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("AirExport.RemoteWarehouse")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Warehouse.DestinationCountry")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "country" },
                                model: {
                                  value: _vm.fbaJob.country,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "country", $$v)
                                  },
                                  expression: "fbaJob.country"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("AirExport.ZipCode") } },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "zipCode" },
                                model: {
                                  value: _vm.fbaJob.zipCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "zipCode", $$v)
                                  },
                                  expression: "fbaJob.zipCode"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "AirExport.DestinationDeliveryMethod"
                                )
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "destinationDistribution",
                                  "select-type":
                                    _vm.selectTypeNames
                                      .local_cache_FbaJobConstants$ORDER_DESTINATION_DISTRIBUTION_TYPES,
                                  filterable: "",
                                  clearable: false,
                                  "default-value":
                                    _vm.fbaJob.destinationDistribution
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.fbaJob.destinationDistribution = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm.fbaJob.destinationDistribution &&
                          Number(_vm.fbaJob.destinationDistribution) === 1
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("AirExport.CourierCompany")
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        no: "expressCompany",
                                        placeholder: "",
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.fbaJob.expressCompany,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.fbaJob,
                                            "expressCompany",
                                            $$v
                                          )
                                        },
                                        expression: "fbaJob.expressCompany"
                                      }
                                    },
                                    _vm._l(
                                      _vm.FbaJobConstants.EXPRESS_COMPANYS,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.code,
                                          attrs: {
                                            label: item.chineseName,
                                            value: item.code
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.fbaJob.destinationDistribution &&
                          Number(_vm.fbaJob.destinationDistribution) === 1
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("AirExport.CourierNumber")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { no: "expressNo" },
                                    model: {
                                      value: _vm.fbaJob.expressNo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fbaJob, "expressNo", $$v)
                                      },
                                      expression: "fbaJob.expressNo"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("AirExport.DomesticWarehouse")
                              }
                            },
                            [
                              _c("cargo-company-select", {
                                attrs: {
                                  no: "warehouseCmp",
                                  "method-params": {
                                    warehouse: true,
                                    active: true
                                  },
                                  "default-value":
                                    Number(_vm.fbaJob.domesticWarehouse) || "",
                                  placeholder: _vm.$t(
                                    "SeaExport.PleaseSelectWarehouse"
                                  )
                                },
                                on: {
                                  change: function(p) {
                                    _vm.fbaJob.domesticWarehouse = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("AirExport.ForeignWarehouse")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "overseaWarehouseCode",
                                  "select-type":
                                    _vm.selectTypeNames
                                      .basic_data_OverseaWarehouse,
                                  filterable: "",
                                  "method-params": { ifFba: false },
                                  clearable: false,
                                  "tag-name": "countryChineseName",
                                  "tag-value": "warehouseCode",
                                  "default-value": _vm.job.overseaWarehouseCode
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.job.overseaWarehouseCode = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "AirExport.CustomsDeclarationMethod"
                                )
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "customsMethodPol",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_CustomsMode,
                                  "method-params": { serviceType: 0 },
                                  filterable: "",
                                  clearable: false,
                                  "default-value": _vm.fbaJob.customsMethodPol
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.fbaJob.customsMethodPol = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SeaExport.CustomsDeclarationType"
                                )
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "customsDeclarationType",
                                  "select-type":
                                    _vm.selectTypeNames
                                      .basic_data_CustomsDeclarationType,
                                  filterable: "",
                                  "default-value":
                                    _vm.job.customsDeclarationType || "",
                                  placeholder: _vm.$t(
                                    "CargoMsg.Cargo_keyWordsTip"
                                  )
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.job.customsDeclarationType = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "AirExport.CustomsClearanceMethod"
                                )
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "customsMethodPod",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_CustomsMode,
                                  "method-params": { serviceType: 1 },
                                  filterable: "",
                                  clearable: false,
                                  "default-value": _vm.fbaJob.customsMethodPod
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.fbaJob.customsMethodPod = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c("hr", {
                            staticStyle: {
                              "margin-top": "20px",
                              "margin-bottom": "20px"
                            }
                          }),
                          _c("span", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.PODDeliveryInformation"))
                            )
                          ]),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "SeaExport.DeliveryToWarehouseMessage"
                                ),
                                label: _vm.$t(
                                  "SeaExport.EstimatedDeliveryToWarehouseTime"
                                )
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "estWarehouseDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.estWarehouseDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "estWarehouseDeliveryTime",
                                      $$v
                                    )
                                  },
                                  expression: "job.estWarehouseDeliveryTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "SeaExport.DeliveryToWarehouseMessage"
                                ),
                                label: _vm.$t(
                                  "SeaExport.ActualDeliveryToWarehouseTime"
                                )
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "actWarehouseDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.actWarehouseDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "actWarehouseDeliveryTime",
                                      $$v
                                    )
                                  },
                                  expression: "job.actWarehouseDeliveryTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "SeaExport.EstimatedDeliveryToCustomersWarehouseMessage"
                                ),
                                label: _vm.$t(
                                  "SeaExport.EstimatedDeliveryToCustomersWarehouseTime"
                                )
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "estGoodsDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.estGoodsDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "estGoodsDeliveryTime",
                                      $$v
                                    )
                                  },
                                  expression: "job.estGoodsDeliveryTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "SeaExport.ActualDeliveryToCustomersWarehouseMessage"
                                ),
                                label: _vm.$t(
                                  "SeaExport.ActualDeliveryToCustomersWarehouseTime"
                                )
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "actGoodsDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.actGoodsDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "actGoodsDeliveryTime",
                                      $$v
                                    )
                                  },
                                  expression: "job.actGoodsDeliveryTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("AirExport.EstimatedDeliveryTime")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "estDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.estDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "estDeliveryTime", $$v)
                                  },
                                  expression: "job.estDeliveryTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("AirExport.ActualDeliveryTime")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "actDeliveryTime",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.job.actDeliveryTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "actDeliveryTime", $$v)
                                  },
                                  expression: "job.actDeliveryTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedField1 &&
              _vm.elementDict.userDefinedField1.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedField1" },
                      slot: "userDefinedField1"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedField1.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedField1.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.userDefinedField1.writable,
                          no: "62",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.userDefinedField1.label,
                              _vm.job.userDefinedField1,
                              function(val) {
                                _vm.job.userDefinedField1 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.userDefinedField1,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField1", $$v)
                          },
                          expression: "job.userDefinedField1"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedField2 &&
              _vm.elementDict.userDefinedField2.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedField2" },
                      slot: "userDefinedField2"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedField2.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedField2.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.userDefinedField2.writable,
                          no: "63",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.userDefinedField2.label,
                              _vm.job.userDefinedField2,
                              function(val) {
                                _vm.job.userDefinedField2 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.userDefinedField2,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField2", $$v)
                          },
                          expression: "job.userDefinedField2"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedField3 &&
              _vm.elementDict.userDefinedField3.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedField3" },
                      slot: "userDefinedField3"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedField3.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedField3.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.userDefinedField3.writable,
                          no: "64",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.userDefinedField3.label,
                              _vm.job.userDefinedField3,
                              function(val) {
                                _vm.job.userDefinedField3 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.userDefinedField3,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField3", $$v)
                          },
                          expression: "job.userDefinedField3"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedField4 &&
              _vm.elementDict.userDefinedField4.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedField4" },
                      slot: "userDefinedField4"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedField4.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedField4.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.viewStatus ||
                            !_vm.elementDict.userDefinedField4.writable,
                          no: "65",
                          type: "textarea",
                          rows: 5
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.userDefinedField4.label,
                              _vm.job.userDefinedField4,
                              function(val) {
                                _vm.job.userDefinedField4 = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.userDefinedField4,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField4", $$v)
                          },
                          expression: "job.userDefinedField4"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.exportControlledProduct &&
              _vm.elementDict.exportControlledProduct.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "exportControlledProduct" },
                      slot: "exportControlledProduct"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.exportControlledProduct.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.exportControlledProduct.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "exportControlledProduct",
                            disabled:
                              _vm.viewStatus ||
                              !_vm.elementDict.exportControlledProduct.writable,
                            placeholder: "",
                            clearable: true,
                            size: "mini"
                          },
                          model: {
                            value: _vm.job.exportControlledProduct,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "exportControlledProduct", $$v)
                            },
                            expression: "job.exportControlledProduct"
                          }
                        },
                        _vm._l(_vm.EXPORT_CONTROLLED_PRODUCT, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.taxNature && _vm.elementDict.taxNature.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "taxNature" }, slot: "taxNature" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.taxNature.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.taxNature.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "taxNature",
                            disabled:
                              _vm.viewStatus ||
                              !_vm.elementDict.taxNature.writable,
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          model: {
                            value: _vm.job.taxNature,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "taxNature", $$v)
                            },
                            expression: "job.taxNature"
                          }
                        },
                        _vm._l(_vm.TAX_NATURES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.boardSales && _vm.elementDict.boardSales.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "boardSales",
                        label: _vm.$t("SeaExport.BoardSales")
                      },
                      slot: "boardSales"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.boardSales.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.boardSales.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, no: "BoardSales", rows: 5 },
                        model: {
                          value: _vm.job.boardSales,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "boardSales", $$v)
                          },
                          expression: "job.boardSales"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.boardCsr && _vm.elementDict.boardCsr.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "boardCsr",
                        label: _vm.$t("SeaExport.BoardCsr")
                      },
                      slot: "boardCsr"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.boardCsr.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.boardCsr.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, no: "BoardCsr", rows: 5 },
                        model: {
                          value: _vm.job.boardCsr,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "boardCsr", $$v)
                          },
                          expression: "job.boardCsr"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.boardSite && _vm.elementDict.boardSite.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "boardSite",
                        label: _vm.$t("SeaExport.BoardSite")
                      },
                      slot: "boardSite"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.boardSite.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.boardSite.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true, no: "BoardSite", rows: 5 },
                        model: {
                          value: _vm.job.boardSite,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "boardSite", $$v)
                          },
                          expression: "job.boardSite"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.arrivalMethod &&
              _vm.elementDict.arrivalMethod.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "arrivalMethod",
                        label: _vm.$t("SeaExport.ArrivalMethod")
                      },
                      slot: "arrivalMethod"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.arrivalMethod.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.arrivalMethod.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: true,
                            placeholder: _vm.$t("Message.PleaseSelect"),
                            size: "mini",
                            no: "ArrivalMethod"
                          },
                          model: {
                            value: _vm.job.arrivalMethod,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "arrivalMethod", $$v)
                            },
                            expression: "job.arrivalMethod"
                          }
                        },
                        _vm._l(_vm.AirExportConstants.ARRIVAL_METHOD, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label:
                                _vm.$store.getters.language === "zh"
                                  ? item.chineseName
                                  : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.flightLabel &&
              _vm.elementDict.flightLabel.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        slot: "flightLabel",
                        label: _vm.$t("SeaExport.FlightLabel")
                      },
                      slot: "flightLabel"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.flightLabel.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.flightLabel.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: true,
                            placeholder: _vm.$t("Message.PleaseSelect"),
                            size: "mini",
                            no: "FlightLabel"
                          },
                          model: {
                            value: _vm.job.flightLabel,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "flightLabel", $$v)
                            },
                            expression: "job.flightLabel"
                          }
                        },
                        _vm._l(
                          _vm.AirExportConstants.AIR_FLIGHT_LABEL,
                          function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label:
                                  _vm.$store.getters.language === "zh"
                                    ? item.chineseName
                                    : item.englishName,
                                value: item.code
                              }
                            })
                          }
                        ),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.goodsInfo && _vm.elementDict.goodsInfo.viewable
                ? _c(
                    "div",
                    {
                      staticClass: "goods-info",
                      staticStyle: { width: "1100px" },
                      attrs: { slot: "goodsInfo" },
                      slot: "goodsInfo"
                    },
                    [
                      _c("el-form-item", { staticClass: "auto-width" }, [
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _c(
                            "div",
                            {
                              staticClass: "title-row",
                              staticStyle: {
                                display: "flex",
                                "text-align": "left"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "188px",
                                    "text-align": "right"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "200px",
                                    "text-align": "right"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.Weight")) +
                                      _vm._s(_vm.openImperial ? "LB" : "KGS")
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "200px",
                                    "text-align": "right"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.Cubage")) +
                                      _vm._s(_vm.openImperial ? "CFT" : "CBM")
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "200px",
                                    "text-align": "right"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ChargedWeight")) +
                                      _vm._s(_vm.openImperial ? "LB" : "KGS")
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "200px",
                                    "text-align": "right"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("queryJob.Density")) + "kg/m³"
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm.showImperialButton && _vm.viewStatus
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "font-weight": "normal",
                                    color: "#404144",
                                    "white-space": "nowrap",
                                    width: "200px",
                                    "text-align": "right",
                                    "padding-left": "50px"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_ImperialUnits")
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      class: _vm.isOpenImperial
                                        ? "el-switch is-checked"
                                        : "el-switch"
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "el-switch__core",
                                        staticStyle: { width: "40px" },
                                        on: {
                                          click: function($event) {
                                            _vm.isOpenImperial = !_vm.isOpenImperial
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.goodsInfoContract &&
              _vm.elementDict.goodsInfoContract.viewable
                ? _c(
                    "div",
                    {
                      staticClass: "goods-info",
                      staticStyle: { width: "1100px" },
                      attrs: { slot: "goodsInfoContract" },
                      slot: "goodsInfoContract"
                    },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "goods-info-item" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.goodsInfoContract.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.$t("SeaExport.Consignation")
                            },
                            slot: "label"
                          }),
                          _c("auto-number-input", {
                            staticStyle: { "margin-left": "0" },
                            attrs: {
                              no: "18",
                              precision: 0,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.quantityContract,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "quantityContract", $$v)
                              },
                              expression: "job.quantityContract"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "weightContractImperial",
                              precision: 2,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.weightContractImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightContractImperial", $$v)
                              },
                              expression: "job.weightContractImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "cubAgeContractImperial",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.cubAgeContractImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubAgeContractImperial", $$v)
                              },
                              expression: "job.cubAgeContractImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "chargeWeightImperial",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.chargeWeightImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "chargeWeightImperial", $$v)
                              },
                              expression: "job.chargeWeightImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "19",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            on: { change: _vm.weightContractChange },
                            model: {
                              value: _vm.job.weightContract,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightContract", $$v)
                              },
                              expression: "job.weightContract"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "20",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            on: { change: _vm.cubageContractChange },
                            model: {
                              value: _vm.job.cubageContract,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubageContract", $$v)
                              },
                              expression: "job.cubageContract"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "21",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.chargeWeight,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "chargeWeight", $$v)
                              },
                              expression: "job.chargeWeight"
                            }
                          }),
                          _c("auto-number-input", {
                            attrs: {
                              precision: 3,
                              min: 0,
                              disabled: true,
                              no: "78"
                            },
                            model: {
                              value: _vm.job.densityContract,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "densityContract", $$v)
                              },
                              expression: "job.densityContract"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.goodsInfoBooking &&
              _vm.elementDict.goodsInfoBooking.viewable
                ? _c(
                    "div",
                    {
                      staticClass: "goods-info",
                      staticStyle: { width: "1100px" },
                      attrs: { slot: "goodsInfoBooking" },
                      slot: "goodsInfoBooking"
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "goods-info-item",
                          attrs: { label: _vm.$t("SeaExport.Booking") }
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.goodsInfoBooking.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.$t("SeaExport.Booking")
                            },
                            slot: "label"
                          }),
                          _c("auto-number-input", {
                            staticStyle: { "margin-left": "0" },
                            attrs: {
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.goodsInfoBooking.writable,
                              no: "22",
                              precision: 0,
                              min: 0
                            },
                            model: {
                              value: _vm.job.quantityBooking,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "quantityBooking", $$v)
                              },
                              expression: "job.quantityBooking"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.goodsInfoBooking.writable,
                              no: "weightBookingImperial",
                              precision: 2,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.weightCubAgeImperialChangeHandler(
                                  "weightBooking"
                                )
                              }
                            },
                            model: {
                              value: _vm.job.weightBookingImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightBookingImperial", $$v)
                              },
                              expression: "job.weightBookingImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.goodsInfoBooking.writable,
                              no: "cubAgeBookingImperial",
                              precision: 3,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.weightCubAgeImperialChangeHandler(
                                  "cubageBooking"
                                )
                              }
                            },
                            model: {
                              value: _vm.job.cubAgeBookingImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubAgeBookingImperial", $$v)
                              },
                              expression: "job.cubAgeBookingImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "chargeWeightBookingImperial",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.chargeWeightBookingImperial,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.job,
                                  "chargeWeightBookingImperial",
                                  $$v
                                )
                              },
                              expression: "job.chargeWeightBookingImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.goodsInfoBooking.writable,
                              no: "23",
                              precision: 3,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.weightCubageChangeHandler(
                                  "weightBooking"
                                )
                              }
                            },
                            model: {
                              value: _vm.job.weightBooking,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightBooking", $$v)
                              },
                              expression: "job.weightBooking"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.goodsInfoBooking.writable,
                              no: "24",
                              precision: 3,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.weightCubageChangeHandler(
                                  "cubageBooking"
                                )
                              }
                            },
                            model: {
                              value: _vm.job.cubageBooking,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubageBooking", $$v)
                              },
                              expression: "job.cubageBooking"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "25",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.chargeWeightBooking,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "chargeWeightBooking", $$v)
                              },
                              expression: "job.chargeWeightBooking"
                            }
                          }),
                          _c("auto-number-input", {
                            attrs: {
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.goodsInfoBooking.writable,
                              precision: 3,
                              min: 0,
                              no: "79"
                            },
                            model: {
                              value: _vm.job.densityBooking,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "densityBooking", $$v)
                              },
                              expression: "job.densityBooking"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.goodsInfoActual &&
              _vm.elementDict.goodsInfoActual.viewable
                ? _c(
                    "div",
                    {
                      staticClass: "goods-info",
                      staticStyle: { width: "1100px" },
                      attrs: { slot: "goodsInfoActual" },
                      slot: "goodsInfoActual"
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "goods-info-item",
                          attrs: { label: _vm.$t("SeaExport.FrontCabinActual") }
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.goodsInfoActual.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.$t("SeaExport.FrontCabinActual")
                            },
                            slot: "label"
                          }),
                          _c("auto-number-input", {
                            staticStyle: { "margin-left": "0" },
                            attrs: {
                              no: "26",
                              precision: 0,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.quantityActual,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "quantityActual", $$v)
                              },
                              expression: "job.quantityActual"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "weightActualImperial",
                              precision: 2,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.weightActualImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightActualImperial", $$v)
                              },
                              expression: "job.weightActualImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "cubAgeActualImperial",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.cubAgeActualImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubAgeActualImperial", $$v)
                              },
                              expression: "job.cubAgeActualImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "cWeightImperial",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.cWeightImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cWeightImperial", $$v)
                              },
                              expression: "job.cWeightImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "27",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            on: { change: _vm.weightActualChange },
                            model: {
                              value: _vm.job.weightActual,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightActual", $$v)
                              },
                              expression: "job.weightActual"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "28",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            on: { change: _vm.cubageActualChange },
                            model: {
                              value: _vm.job.cubageActual,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubageActual", $$v)
                              },
                              expression: "job.cubageActual"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "29",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.weightCubageChangeHandler(
                                  "chargeWeightActual"
                                )
                              }
                            },
                            model: {
                              value: _vm.job.cWeight,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cWeight", $$v)
                              },
                              expression: "job.cWeight"
                            }
                          }),
                          _c("auto-number-input", {
                            attrs: {
                              precision: 3,
                              min: 0,
                              disabled: true,
                              no: "80"
                            },
                            model: {
                              value: _vm.job.densityActual,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "densityActual", $$v)
                              },
                              expression: "job.densityActual"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.goodsInfoDocument &&
              _vm.elementDict.goodsInfoDocument.viewable
                ? _c(
                    "div",
                    {
                      staticClass: "goods-info",
                      staticStyle: { width: "1100px" },
                      attrs: { slot: "goodsInfoDocument" },
                      slot: "goodsInfoDocument"
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "goods-info-item",
                          attrs: { label: _vm.$t("SeaExport.Documentation") }
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.goodsInfoDocument.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.$t("SeaExport.Documentation")
                            },
                            slot: "label"
                          }),
                          _c("auto-number-input", {
                            staticStyle: { "margin-left": "0" },
                            attrs: {
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.goodsInfoDocument.writable,
                              no: "30",
                              precision: 0,
                              min: 0
                            },
                            model: {
                              value: _vm.cargoDoc.quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.cargoDoc, "quantity", $$v)
                              },
                              expression: "cargoDoc.quantity"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.goodsInfoDocument.writable,
                              no: "weightImperial",
                              precision: 2,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.weightCubAgeImperialChangeHandler(
                                  "weight"
                                )
                              }
                            },
                            model: {
                              value: _vm.cargoDoc.weightImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.cargoDoc, "weightImperial", $$v)
                              },
                              expression: "cargoDoc.weightImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.goodsInfoDocument.writable,
                              no: "cubAgeImperial",
                              precision: 3,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.weightCubAgeImperialChangeHandler(
                                  "cubage"
                                )
                              }
                            },
                            model: {
                              value: _vm.cargoDoc.cubAgeImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.cargoDoc, "cubAgeImperial", $$v)
                              },
                              expression: "cargoDoc.cubAgeImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "chargeWeightImperial",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.cargoDoc.chargeWeightImperial,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.cargoDoc,
                                  "chargeWeightImperial",
                                  $$v
                                )
                              },
                              expression: "cargoDoc.chargeWeightImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.goodsInfoDocument.writable,
                              no: "31",
                              precision: 3,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.weightCubageChangeHandler(
                                  "weight"
                                )
                              }
                            },
                            model: {
                              value: _vm.cargoDoc.weight,
                              callback: function($$v) {
                                _vm.$set(_vm.cargoDoc, "weight", $$v)
                              },
                              expression: "cargoDoc.weight"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.goodsInfoDocument.writable,
                              no: "32",
                              precision: 3,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.weightCubageChangeHandler(
                                  "cubage"
                                )
                              }
                            },
                            model: {
                              value: _vm.cargoDoc.cubage,
                              callback: function($$v) {
                                _vm.$set(_vm.cargoDoc, "cubage", $$v)
                              },
                              expression: "cargoDoc.cubage"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "33",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.weightCubageChangeHandler(
                                  "cWeight"
                                )
                              }
                            },
                            model: {
                              value: _vm.cargoDoc.cWeight,
                              callback: function($$v) {
                                _vm.$set(_vm.cargoDoc, "cWeight", $$v)
                              },
                              expression: "cargoDoc.cWeight"
                            }
                          }),
                          _c("auto-number-input", {
                            attrs: {
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.goodsInfoDocument.writable,
                              precision: 3,
                              min: 0,
                              no: "81"
                            },
                            model: {
                              value: _vm.job.densityDoc,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "densityDoc", $$v)
                              },
                              expression: "job.densityDoc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.quantityStation &&
              _vm.elementDict.quantityStation.viewable
                ? _c(
                    "div",
                    {
                      staticClass: "goods-info",
                      staticStyle: { width: "1100px" },
                      attrs: { slot: "quantityStation" },
                      slot: "quantityStation"
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "goods-info-item",
                          attrs: { label: _vm.$t("SeaExport.FreightStation") }
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.quantityStation.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.$t("SeaExport.FreightStation")
                            },
                            slot: "label"
                          }),
                          _c("auto-number-input", {
                            staticStyle: { "margin-left": "0" },
                            attrs: {
                              no: "150",
                              precision: 0,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.quantityStation,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "quantityStation", $$v)
                              },
                              expression: "job.quantityStation"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "weightStationImperial",
                              precision: 2,
                              disabled: true,
                              min: 0
                            },
                            model: {
                              value: _vm.job.weightStationImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightStationImperial", $$v)
                              },
                              expression: "job.weightStationImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "cubAgeStationImperial",
                              precision: 3,
                              disabled: true,
                              min: 0
                            },
                            model: {
                              value: _vm.job.cubAgeStationImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubAgeStationImperial", $$v)
                              },
                              expression: "job.cubAgeStationImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "chargeWeightStationImperial",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.chargeWeightStationImperial,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.job,
                                  "chargeWeightStationImperial",
                                  $$v
                                )
                              },
                              expression: "job.chargeWeightStationImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "151",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            on: {
                              change: function($event) {
                                return _vm.weightStationChange(true)
                              }
                            },
                            model: {
                              value: _vm.job.weightStation,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightStation", $$v)
                              },
                              expression: "job.weightStation"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "152",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            on: {
                              change: function($event) {
                                return _vm.cubageStationChange(true)
                              }
                            },
                            model: {
                              value: _vm.job.cubageStation,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubageStation", $$v)
                              },
                              expression: "job.cubageStation"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "153",
                              precision: 3,
                              disabled: true,
                              min: 0
                            },
                            model: {
                              value: _vm.job.chargeWeightStation,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "chargeWeightStation", $$v)
                              },
                              expression: "job.chargeWeightStation"
                            }
                          }),
                          _c("auto-number-input", {
                            attrs: {
                              precision: 3,
                              min: 0,
                              disabled: true,
                              no: "154"
                            },
                            model: {
                              value: _vm.job.densityStation,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "densityStation", $$v)
                              },
                              expression: "job.densityStation"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.quantitySigning &&
              _vm.elementDict.quantitySigning.viewable
                ? _c(
                    "div",
                    {
                      staticClass: "goods-info",
                      staticStyle: { width: "1100px" },
                      attrs: { slot: "goodsInfo" },
                      slot: "goodsInfo"
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "goods-info-item",
                          attrs: { label: _vm.$t("SeaExport.SignBill") }
                        },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.quantitySigning.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.$t("SeaExport.SignBill")
                            },
                            slot: "label"
                          }),
                          _c("auto-number-input", {
                            staticStyle: { "margin-left": "0" },
                            attrs: {
                              no: "156",
                              precision: 0,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.quantitySigning,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "quantitySigning", $$v)
                              },
                              expression: "job.quantitySigning"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "weightSigningImperial",
                              precision: 2,
                              min: 0,
                              disabled: true
                            },
                            on: { change: _vm.weightSigningChange },
                            model: {
                              value: _vm.job.weightSigningImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightSigningImperial", $$v)
                              },
                              expression: "job.weightSigningImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "cubAgeSigningImperial",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            on: { change: _vm.cubageSigningChange },
                            model: {
                              value: _vm.job.cubAgeSigningImperial,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubAgeSigningImperial", $$v)
                              },
                              expression: "job.cubAgeSigningImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openImperial,
                                expression: "openImperial"
                              }
                            ],
                            attrs: {
                              no: "chargeWeightSigningImperial",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            model: {
                              value: _vm.job.chargeWeightSigningImperial,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.job,
                                  "chargeWeightSigningImperial",
                                  $$v
                                )
                              },
                              expression: "job.chargeWeightSigningImperial"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "157",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            on: { change: _vm.weightSigningChange },
                            model: {
                              value: _vm.job.weightSigning,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightSigning", $$v)
                              },
                              expression: "job.weightSigning"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "158",
                              precision: 3,
                              min: 0,
                              disabled: true
                            },
                            on: { change: _vm.cubageSigningChange },
                            model: {
                              value: _vm.job.cubageSigning,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubageSigning", $$v)
                              },
                              expression: "job.cubageSigning"
                            }
                          }),
                          _c("auto-number-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.openImperial,
                                expression: "!openImperial"
                              }
                            ],
                            attrs: {
                              no: "159",
                              precision: 3,
                              disabled: true,
                              min: 0
                            },
                            model: {
                              value: _vm.job.chargeWeightSigning,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "chargeWeightSigning", $$v)
                              },
                              expression: "job.chargeWeightSigning"
                            }
                          }),
                          _c("auto-number-input", {
                            attrs: {
                              precision: 3,
                              min: 0,
                              disabled: true,
                              no: "160"
                            },
                            model: {
                              value: _vm.job.densitySigning,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "densitySigning", $$v)
                              },
                              expression: "job.densitySigning"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.packing && _vm.elementDict.packing.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "fit-content" },
                      attrs: { slot: "packing" },
                      slot: "packing"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.packing.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.packing.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-packing-select", {
                        staticStyle: { width: "186px" },
                        attrs: {
                          no: "46",
                          "default-value": _vm.job.packing,
                          disabled:
                            _vm.viewStatus || !_vm.elementDict.packing.writable,
                          "callback-params": {},
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            p.key = "packing"
                            _vm.setJobSelectValue(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.slac && _vm.elementDict.slac.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: {
                        "margin-left": "10px",
                        width: "fit-content"
                      },
                      attrs: { slot: "slac", "label-width": "100px" },
                      slot: "slac"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.slac.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.slac.label
                        },
                        slot: "label"
                      }),
                      _c("el-input-number", {
                        staticStyle: { width: "88px" },
                        attrs: {
                          no: "slac",
                          min: 0,
                          precision: 0,
                          controls: false,
                          disabled:
                            _vm.viewStatus || !_vm.elementDict.slac.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.slacChangeHandler(p)
                          }
                        },
                        model: {
                          value: _vm.job.slac,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "slac", $$v)
                          },
                          expression: "job.slac"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoEnglishName &&
              _vm.elementDict.cargoEnglishName.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      staticStyle: { width: "290px" },
                      attrs: { slot: "cargoEnglishName" },
                      slot: "cargoEnglishName"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoEnglishName.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoEnglishName.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { position: "relative" } },
                        [
                          _c("cargo-textarea", {
                            attrs: {
                              no: "17",
                              type: "textarea",
                              rows: 5,
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.cargoEnglishName.writable,
                              "auto-uppercase": _vm.isUppercaseByConfig
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.elementDict.cargoEnglishName.lab,
                                  _vm.job.cargoEnglishName,
                                  function(val) {
                                    _vm.pm.cargoEnglishNameChangeHandler(val)
                                  },
                                  true,
                                  null,
                                  _vm.isUppercaseByConfig,
                                  {
                                    maxChar: 0
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.job.cargoEnglishName,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cargoEnglishName", $$v)
                              },
                              expression: "job.cargoEnglishName"
                            }
                          }),
                          _c("char-count", {
                            attrs: { value: _vm.job.cargoEnglishName }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.mark && _vm.elementDict.mark.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      staticStyle: { width: "290px" },
                      attrs: { slot: "mark" },
                      slot: "mark"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.mark.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.mark.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { position: "relative" } },
                        [
                          _c("cargo-textarea", {
                            attrs: {
                              no: "41",
                              type: "textarea",
                              rows: 5,
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.mark.writable,
                              "auto-uppercase": _vm.isUppercaseByConfig
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.elementDict.mark.label,
                                  _vm.job.mark,
                                  function(val) {
                                    _vm.pm.markChangeHandler(val)
                                  },
                                  true,
                                  null,
                                  _vm.isUppercaseByConfig,
                                  {
                                    maxChar: 0
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.job.mark,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "mark", $$v)
                              },
                              expression: "job.mark"
                            }
                          }),
                          _c("char-count", { attrs: { value: _vm.job.mark } })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoChineseName &&
              _vm.elementDict.cargoChineseName.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      staticStyle: { width: "290px" },
                      attrs: { slot: "cargoChineseName" },
                      slot: "cargoChineseName"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoChineseName.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoChineseName.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { position: "relative" } },
                        [
                          _c("cargo-textarea", {
                            attrs: {
                              no: "49",
                              type: "textarea",
                              rows: 5,
                              disabled:
                                _vm.viewStatus ||
                                !_vm.elementDict.cargoChineseName.writable
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showAdvanceTextDialog(
                                  _vm.elementDict.cargoChineseName.label,
                                  _vm.job.cargoChineseName,
                                  function(val) {
                                    _vm.job.cargoChineseName = val
                                  },
                                  true,
                                  null,
                                  true,
                                  {
                                    maxChar: 0
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.job.cargoChineseName,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cargoChineseName", $$v)
                              },
                              expression: "job.cargoChineseName"
                            }
                          }),
                          _c("char-count", {
                            attrs: { value: _vm.job.cargoChineseName }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.rateType && _vm.elementDict.rateType.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "rateType" }, slot: "rateType" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.rateType.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.rateType.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled:
                              _vm.viewStatus ||
                              !_vm.elementDict.rateType.writable,
                            no: "rateType",
                            clearable: "",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          model: {
                            value: _vm.job.rateType,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "rateType", $$v)
                            },
                            expression: "job.rateType"
                          }
                        },
                        _vm._l(_vm.rateType, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "section",
                  attrs: { slot: "ticketsInfo" },
                  slot: "ticketsInfo"
                },
                [
                  _c("div", { staticClass: "form-row" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.TicketsInfo")))
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "flex-start",
                          "margin-bottom": "5px",
                          "line-height": "28px"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("SeaExport.TotalTickets")) + ":")
                        ]),
                        _c("span", { staticStyle: { "margin-right": "5px" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.job.lclSlaves ? _vm.job.lclSlaves.length : 0
                            )
                          )
                        ]),
                        _vm.viewStatus && _vm.viewSource === "AeBooking"
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.cooperateEdit,
                                    expression: "cooperateEdit"
                                  }
                                ],
                                staticClass: "triggers"
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { no: "66", type: "primary" },
                                    on: { click: _vm.newSubJobHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.NewTickets"))
                                    )
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "67",
                                      type: "primary",
                                      disabled: !_vm.selectedRow
                                    },
                                    on: { click: _vm.editSubJobHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.EditTickets"))
                                    )
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "68",
                                      type: "primary",
                                      disabled:
                                        Number(_vm.job.operateType) !== 0
                                    },
                                    on: { click: _vm.attachSubJobHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.AddTickets"))
                                    )
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "69",
                                      type: "danger",
                                      disabled:
                                        !_vm.selectedRow ||
                                        _vm.viewSource === "financeDetail"
                                    },
                                    on: { click: _vm.detachSubJobHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.RemoveTickets"))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "min-height": "200px",
                          "flex-direction": "column"
                        }
                      },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { height: "350px" },
                          attrs: {
                            "config-module": "150006",
                            "grid-options": _vm.gridOptions,
                            "column-defs": _vm.columnDefs,
                            "row-data": _vm.rowData
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.gridApi = params.api
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            ],
            2
          )
        ],
        1
      ),
      _c("transit-port-dialog", {
        attrs: { visible: _vm.transitPortDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.transitPortDialog, "visible", $event)
          },
          enter: _vm.transitPortEnterHandler
        }
      }),
      _c("select-mawb-dialog", {
        attrs: {
          visible: _vm.selectMawbDialog.visible,
          "carrier-id": _vm.selectMawbDialog.carrierId,
          type: _vm.selectMawbDialog.type,
          "operate-type": _vm.selectMawbDialog.operateType
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectMawbDialog, "visible", $event)
          },
          enterEvent: _vm.selectedMAWBHandler
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "70",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            },
            close: _vm.closeAdvanceText
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.viewStatus,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              no: "85"
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.viewStatus,
                      expression: "!viewStatus"
                    }
                  ],
                  attrs: { no: "71", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "71_1" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                      _vm.closeAdvanceText()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "72",
            visible: _vm.ticketDialog.visible,
            title: _vm.$t("SeaExport.FillInQuantityOfVotes"),
            width: "270px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.ticketDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "50px", "label-position": "right" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Number") + "：" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      no: "73",
                      precision: 0,
                      min: 1,
                      max: 50,
                      controls: false
                    },
                    model: {
                      value: _vm.ticketDialog.value,
                      callback: function($$v) {
                        _vm.$set(_vm.ticketDialog, "value", $$v)
                      },
                      expression: "ticketDialog.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "74", type: "primary" },
                  on: { click: _vm.toAddTicket }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "75", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.ticketDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("query-ae-lcl-dialog", {
        attrs: { visible: _vm.queryAeLclDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.queryAeLclDialog, "visible", $event)
          },
          attachSubJobCallBackHandler: _vm.attachSubJobCallBackHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }